import { useMemo } from 'react';
import { ParseKeys } from 'i18next';
import { useTranslation } from 'next-i18next';
import { ChannelIcon, ChartLineIcon, FaceFillIcon, GearFillIcon, InformationmarkSmallCircleIcon, PaperFillIcon, ScreenArrowupFillIcon, SquareGridPlusFillIcon } from '@zep/icons';
import { Button, Spacing } from '@zep/ui';
import { Colors } from '@zep/ui-tokens';
export const EnterprisePlanTabsContent = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const features = useMemo(() => [{
    icon: <GearFillIcon width={14} height={14} fill={Colors.Gray600} />,
    text: t('subscription:pricing.pro.feature2', 'URL, 로고 커스터마이징')
  }, {
    icon: <SquareGridPlusFillIcon width={14} height={14} fill={Colors.Gray600} />,
    text: t('subscription:pricing.enterprise.paymentFeature', '무제한 앱 제공')
  }, {
    icon: <PaperFillIcon width={14} height={14} fill={Colors.Gray600} />,
    text: t('subscription:pricing.pro.feature4', 'Google 애널리틱스 연동 ')
  }, {
    icon: <ChartLineIcon width={14} height={14} fill={Colors.Gray600} />,
    text: t('subscription:pricing.enterprise.feature2', '데이터 대시보드 제공 ')
  }, {
    icon: <FaceFillIcon width={14} height={14} fill={Colors.Gray600} />,
    text: t('subscription:pricing.enterprise.feature4', '전담 매니저 할당')
  }, {
    icon: <ScreenArrowupFillIcon width={14} height={14} fill={Colors.Gray600} />,
    text: t('subscription:pricing.enterprise.feature3', '엔터프라이즈 전용 서버 할당')
  }, {
    icon: <ChannelIcon width={14} height={14} fill={Colors.Gray600} />,
    text: t('subscription:pricing.enterprise.feature5', '채널링 조정')
  }], [t]);
  return <>
      <div className="grid w-full grid-cols-2 items-center gap-x-[8px] gap-y-[12px] rounded-[10px] border border-gray-200 bg-gray-50 px-[26px] py-[20px]">
        {features.map((feature, index) => <div key={index} className="flex items-center gap-[8px]">
            <span>{feature.icon}</span>
            <span className="text-[12px] font-[500] text-gray-600">
              {feature.text as ParseKeys}
            </span>
          </div>)}
      </div>
      <Spacing size={14} data-sentry-element="Spacing" data-sentry-source-file="EnterprisePlanTabsContent.tsx" />
      <div className="flex items-center gap-[4px]">
        <InformationmarkSmallCircleIcon width={14} height={14} fill={'#27262EA3'} data-sentry-element="InformationmarkSmallCircleIcon" data-sentry-source-file="EnterprisePlanTabsContent.tsx" />
        <span className="text-caption-1 font-[600] text-[#27262EA3]">
          {t('subscription:payment.duration.contactDescription', '엔터프라이즈 도입은 사업팀에 문의해 주세요.')}
        </span>
        <span className="text-caption-1 font-[600] text-blue">
          <Button size="xxs" variant="white" transparent className="!text-blue" onClick={() => {
          window.open(t('subscription:subscription.salesmap.link'), '_blank');
        }} data-sentry-element="Button" data-sentry-source-file="EnterprisePlanTabsContent.tsx">
            {t('subscription:payment.duration.contact', '도입 문의하기')}
          </Button>
        </span>
      </div>
    </>;
};